import { ServiceType } from '@rover/constants/src/translations/service.constants';
import { captureGroup, union } from '@rover/shared/js/utils/regex';
import { COUNTRY_URL_PREFIXES_REGEX_PATTERN } from '@rover/utilities/roverGeo.constants';

const SEO_LOCATION_SERVICE_BASE_REGEX = /[-_a-z0-9]+--[a-z-]+--[a-z-]+/;
const getServiceSpecificCityServiceRegex = (serviceType: SeoSlugEnum) =>
  new RegExp(`[-_a-z0-9]+--[a-z-]+--${serviceType}+`);

const SEO_NEIGHBORHOOD_SERVICE_ROUTE_REGEX = new RegExp(
  `[-_a-z0-9]+--${SEO_LOCATION_SERVICE_BASE_REGEX.source}`
);
// Include a negative lookahead to exclude neighborhood pages,
// but still match if there is a leading slash
const SEO_CITY_SERVICE_ROUTE_REGEX = new RegExp(
  `^(?:/)?(?!${SEO_NEIGHBORHOOD_SERVICE_ROUTE_REGEX.source})${SEO_LOCATION_SERVICE_BASE_REGEX.source}`
);

const SEO_CITY_AND_NEIGHBORHOOD_LANDING_ROUTE_REGEX_PATTERN = union(
  SEO_LOCATION_SERVICE_BASE_REGEX.source,
  SEO_NEIGHBORHOOD_SERVICE_ROUTE_REGEX.source
);

const INTL_SEO_CITY_AND_NEIGHBORHOOD_LANDING_ROUTE_REGEX_PATTERN = [
  captureGroup(COUNTRY_URL_PREFIXES_REGEX_PATTERN),
  captureGroup(SEO_CITY_AND_NEIGHBORHOOD_LANDING_ROUTE_REGEX_PATTERN),
].join('/');

const US_AND_INTL_SEO_CITY_AND_NEIGHBORHOOD_ROUTE_REGEX_PATTERN = union(
  captureGroup(INTL_SEO_CITY_AND_NEIGHBORHOOD_LANDING_ROUTE_REGEX_PATTERN),
  captureGroup(SEO_CITY_AND_NEIGHBORHOOD_LANDING_ROUTE_REGEX_PATTERN)
);

export enum SeoSlugEnum {
  DOG_BOARDING = 'dog-boarding',
  DOG_WALKING = 'dog-walking',
  DOGGY_DAY_CARE = 'doggy-day-care',
  HOUSE_SITTING = 'house-sitting',
  CAT_SITTING = 'cat-sitting',
  PET_SITTING = 'pet-sitting',
  DOG_TRAINING = 'dog-training',
  DOG_SITTING = 'dog-sitting',
  PET_BOARDING = 'pet-boarding',
}

export const SEO_LOCATION_REGEX = {
  CITY_SERVICE: SEO_CITY_SERVICE_ROUTE_REGEX,
  NEIGHBORHOOD_SERVICE: SEO_NEIGHBORHOOD_SERVICE_ROUTE_REGEX,
  CITY_AND_NEIGHBORHOOD_SERVICE: new RegExp(SEO_CITY_AND_NEIGHBORHOOD_LANDING_ROUTE_REGEX_PATTERN),
  INTL_CITY_AND_NEIGHBORHOOD_SERVICE: new RegExp(
    INTL_SEO_CITY_AND_NEIGHBORHOOD_LANDING_ROUTE_REGEX_PATTERN
  ),
  ALL_SEO_CITY_AND_NEIGHBORHOOD_SERVICE: new RegExp(
    US_AND_INTL_SEO_CITY_AND_NEIGHBORHOOD_ROUTE_REGEX_PATTERN
  ),
  DOG_TRAINING_CITY_SERVICE: getServiceSpecificCityServiceRegex(SeoSlugEnum.DOG_TRAINING),
};

export const SERVICE_TYPE_FOR_SEO_SLUG: Record<SeoSlugEnum, ServiceType> = {
  [SeoSlugEnum.DOG_BOARDING]: ServiceType.OVERNIGHT_BOARDING,
  [SeoSlugEnum.DOG_WALKING]: ServiceType.DOG_WALKING,
  [SeoSlugEnum.DOGGY_DAY_CARE]: ServiceType.DOGGY_DAY_CARE,
  [SeoSlugEnum.HOUSE_SITTING]: ServiceType.OVERNIGHT_TRAVELING,
  [SeoSlugEnum.CAT_SITTING]: ServiceType.DROP_IN,
  [SeoSlugEnum.PET_SITTING]: ServiceType.DROP_IN,
  [SeoSlugEnum.DOG_TRAINING]: ServiceType.DOG_TRAINING,
  [SeoSlugEnum.DOG_SITTING]: ServiceType.DROP_IN,
  [SeoSlugEnum.PET_BOARDING]: ServiceType.OVERNIGHT_BOARDING,
};
